import { useCleanText } from "@/shared/client";
import { type MainInfoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { getDefaultParameters, removeHtmlTags } from "@/utils";
import { Box, Flex, Img } from "@chakra-ui/react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useLocation } from "react-router-dom";
import { TextFit } from "../textFit";
import { CustomBox, CustomContainer, CustomText } from "./banner.style";

export const Banner = ({ imgList, catchPraise }: MainInfoResponse) => {
    const { main, sub } = catchPraise;
    const { isTablet, isMobile } = MEDIA();
    const { cleanText } = useCleanText(sub.secondLine);
    const { pathname } = useLocation();
    // const vimeoValue = useVimemoValue();
    const { idx } = getDefaultParameters();

    const isSuiteVideo = idx === "2017" && pathname.includes("home");
    const isSuiteCase = (idx === "2017" && pathname.includes("specials")) || pathname.includes("rooms");

    const ElemetnChild = [
        // <VimeoPlayer key={vimeoValue.id} id={vimeoValue.id} isSound={vimeoValue.isSound} />,
        ...imgList.map((img) => (
            <Box
                zIndex={2}
                key={img.imgUrl}
                w="100%"
                h="100vh"
                background={`url(${img.imgUrl}) no-repeat center/cover`}
            />
        )),
    ];
    return (
        <CustomContainer position="relative" w="100%" maxW="100%" p="0" m="0">
            <Flex
                w="90%"
                maxW={isMobile ? "200px" : "1600px"}
                flexDir="column"
                position="absolute"
                rowGap="16px"
                textShadow="1px 0 3px rgba(0, 0, 0, 0.4)"
                pointerEvents="none"
                top="50%"
                left={isMobile ? "10%" : "50%"}
                zIndex="1"
                transform={`translate(${isMobile ? "none" : "-50%"},-50%)`}
            >
                <Box>
                    <TextFit max={isMobile ? 32 : 60} color="#fff">
                        {removeHtmlTags(main.firstLine, "<br>").cleanText}
                    </TextFit>
                    <TextFit max={isMobile ? 24 : 60} color="#fff">
                        {removeHtmlTags(main.secondLine, "<br>").cleanText}
                    </TextFit>
                </Box>
                {!isMobile && pathname.includes("specials") && (
                    <CustomBox>
                        <CustomText mb="4px">{sub.firstLine}</CustomText>
                        <CustomText>
                            {!isSuiteCase && (
                                <Flex flexDir="column" gap="4px">
                                    {Array.isArray(cleanText)
                                        ? cleanText.map((text) => <p key={text}>{text}</p>)
                                        : cleanText}
                                </Flex>
                            )}
                        </CustomText>
                    </CustomBox>
                )}
            </Flex>
            <Carousel
                showArrows={false}
                showStatus={false}
                showThumbs={false}
                showIndicators={!isTablet ?? false}
                interval={3000}
                infiniteLoop
                autoPlay
                emulateTouch
                preventMovementUntilSwipeScrollTolerance
                swipeScrollTolerance={100}
            >
                {isSuiteVideo
                    ? ElemetnChild
                    : imgList.map((img) => (
                          <Img key={`${img.imgUrl}`} w="100%" h={isMobile ? "300px" : "100vh"} src={img.imgUrl}></Img>
                      ))}
            </Carousel>
        </CustomContainer>
    );
};
